import React from 'react';

import { useParams } from 'react-router-dom';

import { ReactComponent as EditIcon } from '@pkg/assets/icons/v2/edit.svg';
import { useAppDispatch } from '@pkg/hooks';

import { type YatPageItemNFTResponse } from '@app/client';
import { PathParams } from '@app/routes/types';
import { wishlistActions } from '@app/store/slices';

import { Wrapper } from './styles';

interface Props {
    wishListModalData: Partial<YatPageItemNFTResponse>;
}

export const WishlistManageButton = ({ wishListModalData }: Props) => {
    const dispatch = useAppDispatch();

    const { [PathParams.WishlistSlug]: wishlistSlug } = useParams();

    const handleShowWishlistModal = () => {
        dispatch(wishlistActions.setWishListModalData(wishListModalData));

        dispatch(wishlistActions.setWishListModalSlug(wishlistSlug || null));
        dispatch(wishlistActions.setWishListToastSlug(null));
        dispatch(wishlistActions.setWishListToastName(null));
    };

    return (
        <Wrapper title="Manage" onClick={handleShowWishlistModal}>
            <EditIcon />
        </Wrapper>
    );
};
